import {
  Accordion, useSections,
} from '~/_shared/baseComponents/accordion';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { useBoundaryTerritoryGroupsGroupedByBoundaryGroupSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import { BoundaryTerritoryGroupKeyContainer } from './boundaryTerritoryGroupKey.container';

export const BoundaryKey = () => {
  const boundaryTerritoryGroupsByBoundaryGroupId = useBoundaryTerritoryGroupsGroupedByBoundaryGroupSelector();

  const { toggleSection, isExpanded } = useSections<BoundaryGroupId>(
    boundaryTerritoryGroupsByBoundaryGroupId.map(({ boundaryGroupId }) => boundaryGroupId)
  );

  return (
    <Accordion>
      {boundaryTerritoryGroupsByBoundaryGroupId
        .map(({ boundaryGroupId, boundaryTerritoryGroups }) => (
          <BoundaryTerritoryGroupKeyContainer
            key={boundaryGroupId}
            boundaryGroupId={boundaryGroupId}
            boundaryTerritoryGroups={boundaryTerritoryGroups}
            isExpanded={isExpanded(boundaryGroupId)}
            onToggle={() => toggleSection(boundaryGroupId)}
          />
        ))}
    </Accordion>
  );
};
